module.exports = __webpack_public_path__ + "static/media/bni-2.daf3f8a9.png";